/* Absolute Furniture Warehouse – v2 header, Deal of the Week and product extras (loads after afw.js) */
(function () {
  'use strict';
  if (window.__afwV2) return; window.__afwV2 = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Shared: site data, Brisbane time, deals, showroom hours ---------- */
  var SITE = (function () { try { return JSON.parse(document.getElementById('afwSiteData').textContent); } catch (e) { return { stores: [], deals: [] }; } })();
  var BNE = 10 * 3600 * 1000;
  function bneNow() { return new Date(Date.now() + BNE); }            // read with getUTC*
  function thisSundayEnd() {
    var b = bneNow(), daysLeft = (7 - b.getUTCDay()) % 7;
    return Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate()) + daysLeft * 86400000 + 86399000 - BNE;
  }
  function currentDeal() {
    // A deal is live from its start date through the end of its "until" date
    // (Brisbane time), inclusive. No "until" set means it runs until the next
    // deal's start date supersedes it. Among deals currently live, the one
    // with the latest start date wins.
    var today = bneNow().toISOString().slice(0, 10), pick = null;
    (SITE.deals || []).forEach(function (d) {
      if (!d.from || d.from > today) return;
      if (d.until && d.until < today) return;
      if (!pick || d.from >= pick.from) pick = d;
    });
    return pick;
  }
  function parseHours(str) {                                          // "1,2,3,4,5=9-15;0,6=9-12"
    var map = {};
    String(str || '').split(';').forEach(function (part) {
      var kv = part.split('='); if (kv.length < 2) return;
      var t = kv[1].split('-').map(parseFloat);
      kv[0].split(',').forEach(function (d) { d = parseInt(d, 10); if (!isNaN(d)) map[d] = t; });
    });
    return map;
  }
  function fmtHour(h) { var m = Math.round((h % 1) * 60), hh = Math.floor(h); return (hh > 12 ? hh - 12 : hh) + (m ? ':' + pad(m) : '') + (hh >= 12 ? 'pm' : 'am'); }
  function joinNames(names) {                                          // ["Rocklea"] -> "Rocklea"; ["Rocklea","Enoggera"] -> "Rocklea and Enoggera"; 3+ -> Oxford-comma list
    if (names.length < 2) return names[0] || '';
    if (names.length === 2) return names[0] + ' and ' + names[1];
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }
  function storeStatus(stores) {
    var b = bneNow(), day = b.getUTCDay(), hr = b.getUTCHours() + b.getUTCMinutes() / 60, DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var list = (stores || []).map(function (s) { return { name: s.name, h: parseHours(s.hours) }; });
    var open = list.filter(function (s) { var x = s.h[day]; return x && hr >= x[0] && hr < x[1]; });
    if (open.length) {
      var untilH = Math.max.apply(null, open.map(function (s) { return s.h[day][1]; }));
      return { open: true, text: joinNames(open.map(function (s) { return s.name; })) + ' open now · until ' + fmtHour(untilH) };
    }
    for (var k = 0; k < 8; k++) {
      var d = (day + k) % 7;
      var next = list.filter(function (s) { var x = s.h[d]; return x && !(k === 0 && hr >= x[0]); });
      if (next.length) {
        var minH = Math.min.apply(null, next.map(function (s) { return s.h[d][0]; }));
        var atMin = next.filter(function (s) { return s.h[d][0] === minH; });
        return { open: false, text: joinNames(atMin.map(function (s) { return s.name; })) + ' opens ' + (k === 0 ? 'today' : k === 1 ? 'tomorrow' : DAYS[d]) + ' ' + fmtHour(minH) };
      }
    }
    return { open: false, text: '' };
  }
  window.AFW = { site: SITE, currentDeal: currentDeal, thisSundayEnd: thisSundayEnd, storeStatus: storeStatus };

  function toast(msg) {
    var t = document.getElementById('afwToast');
    if (!t) { t = document.createElement('div'); t.className = 'afw-home-toast'; document.body.appendChild(t); t.id = 'afwToast2'; }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var root = $('#afwHdr'), header = $('#afwSiteHeader'); if (!root || root._afw) return; root._afw = true;
    var compact = false, hs = $('#afwHdrSearch');
    function onScroll() {
      var c = window.scrollY > 60;
      if (c !== compact) { compact = c; root.classList.toggle('is-compact', c); header.classList.toggle('is-compact', c); if (!c && hs) hs.classList.remove('is-forced'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var input = $('#afwSiteSearch'), pop = $('#afwSearchPop'), results = $('#afwSearchResults');
    function escHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function renderSearchResults(products, query) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = '<p class="s-empty">No products found for &ldquo;' + escHtml(query) + '&rdquo;</p>';
      } else {
        results.innerHTML = '<ul class="s-results-list">' + products.map(function (p) {
          var img = p.image ? '<img src="' + escHtml(p.image) + '" width="40" height="40" alt="" loading="lazy">' : '<span class="s-noimg">' + '</span>';
          var price = p.price ? '<span class="s-price">' + escHtml(p.price) + '</span>' : '';
          return '<li><a href="' + escHtml(p.url) + '">' + img + '<span class="s-info"><span class="s-title">' + escHtml(p.title) + '</span>' + price + '</span></a></li>';
        }).join('') + '</ul>';
      }
      results.hidden = false;
      if (pop) pop.hidden = true;
    }
    if (input) {
      var searchTimer, searchAbort;
      input.addEventListener('focus', function () {
        var q = input.value.trim();
        if (q.length < 2) { if (pop) pop.hidden = false; if (results) results.hidden = true; }
        else if (results && results.innerHTML) { results.hidden = false; if (pop) pop.hidden = true; }
      });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) {
          if (results) { results.hidden = true; results.innerHTML = ''; }
          if (pop) pop.hidden = false;
          return;
        }
        searchTimer = setTimeout(function () {
          if (searchAbort) searchAbort.abort();
          searchAbort = ('AbortController' in window) ? new AbortController() : null;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor', searchAbort ? { signal: searchAbort.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
              renderSearchResults(products, q);
            })
            .catch(function (err) { if (!err || err.name !== 'AbortError') { /* silent */ } });
        }, 220);
      });
      document.addEventListener('click', function (e) { if (!hs.contains(e.target) && !e.target.closest('#afwMSearchBtn')) { if (pop) pop.hidden = true; if (results) results.hidden = true; } });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (pop) pop.hidden = true; if (results) results.hidden = true; input.blur(); } });
    }
    var ms = $('#afwMSearchBtn'); if (ms && hs) ms.addEventListener('click', function () { hs.classList.add('is-forced'); if (input) input.focus(); });
    var megaBtn = $('#afwMegaBtn'), megaPanel = $('#afwMegaPanel');
    if (megaBtn && megaPanel) {
      function closeMega() { megaPanel.hidden = true; megaBtn.setAttribute('aria-expanded', 'false'); }
      function openMega() { megaPanel.hidden = false; megaBtn.setAttribute('aria-expanded', 'true'); }
      megaBtn.addEventListener('click', function () { if (megaPanel.hidden) openMega(); else closeMega(); });
      document.addEventListener('click', function (e) { if (!megaPanel.hidden && !megaPanel.contains(e.target) && e.target !== megaBtn && !megaBtn.contains(e.target)) closeMega(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !megaPanel.hidden) { closeMega(); megaBtn.focus(); } });
    }
    var drawer = $('#afwDrawer'), menuBtn = $('#afwMenuBtn'), last;
    // Move the drawer to be a direct child of <body>, outside the header's
    // section wrapper. That wrapper is position:sticky with a lower z-index
    // than the announcement bar's wrapper, which traps the drawer's own
    // z-index inside a losing stacking context no matter how high it is set.
    // As a direct child of <body> it competes at the top level instead,
    // where its z-index:60 straightforwardly beats everything else on the page.
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
    function openD() { last = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); menuBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; var c = $('.afwd-head .icon-btn', drawer); if (c) c.focus(); }
    function closeD() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); menuBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; if (last) last.focus(); }
    if (drawer && menuBtn) {
      menuBtn.addEventListener('click', openD);
      drawer.addEventListener('click', function (e) { if (e.target.closest('[data-afw-close-drawer]')) closeD(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeD(); });
    }
    function status() {
      var st = storeStatus(SITE.stores); if (!st.text) return;
      $$('[data-afw-status]').forEach(function (el) { el.classList.toggle('is-open', st.open); });
      $$('[data-afw-status-text]').forEach(function (el) { el.textContent = st.text; });
    }
    status(); setInterval(status, 60000);
    var deal = currentDeal(), teaser = $('[data-afw-deal-teaser]');
    if (teaser) {
      var dealMsg = $('[data-afw-deal-msg]', teaser), dealTag = $('[data-afw-deal-tag]', teaser);
      if (deal) {
        var extraNote = deal.extra > 0 ? ' (down an extra $' + deal.extra + ')' : '';
        dealMsg.textContent = deal.title + ', now ' + (deal.price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0 }) + extraNote + ' →';
        teaser.href = deal.url;
      } else {
        dealTag.textContent = 'Clearance';
        dealMsg.textContent = (teaser.getAttribute('data-fallback') || '') + ' — shop now →';
        teaser.href = '/collections/clearance';
      }
    }
  }

  function footerStores() {
    $$('[data-afw-footer-store]').forEach(function (el) {
      var name = el.getAttribute('data-afw-footer-store');
      var list = (SITE.stores || []).filter(function (x) { return x.name === name; });
      el.classList.toggle('is-open', list.length > 0 && storeStatus(list).open);
    });
  }

  /* Keep the page clear of the fixed header.
     Capped defensively: if a transient layout state (font swap, editor live-reload,
     an open mega menu, etc.) is ever measured mid-change, this stops it from
     locking in a huge reserved gap above the page content. */
  var AFW_HEADER_MAX = 260;
  function syncHeaderSpace() {
    var a = document.getElementById('shopify-section-afw-announcement'), h = document.getElementById('shopify-section-afw-header');
    var root = $('#afwHdr'), ah = a ? Math.min(a.offsetHeight, 80) : 0;
    document.documentElement.style.setProperty('--afw-ann-h', ah + 'px');
    if (h && !(root && root.classList.contains('is-compact'))) {
      var hh = Math.min(h.offsetHeight, AFW_HEADER_MAX - ah);
      document.documentElement.style.setProperty('--afw-top-h', (ah + hh) + 'px');
    }
  }

  /* Weekly countdowns (to this Sunday 11:59pm Brisbane) */
  function initWeekly() {
    var cds = $$('[data-afw-weekly-cd]'); if (!cds.length) return;
    function tick() {
      var left = Math.max(0, Math.floor((thisSundayEnd() - Date.now()) / 1000));
      cds.forEach(function (cd) {
        var set = function (u, v) { var el = cd.querySelector('[data-u="' + u + '"]'); if (el) el.textContent = v; };
        set('d', pad(Math.floor(left / 86400))); set('h', pad(Math.floor(left % 86400 / 3600)));
        set('m', pad(Math.floor(left % 3600 / 60))); set('s', pad(left % 60));
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Product page extras ---------- */
  function initProduct(root) {
    if (root._afwV2) return; root._afwV2 = true;
    var product = null; try { product = JSON.parse($('[data-afw-product-json]', root).textContent); } catch (e) {}
    var currency = root.getAttribute('data-currency') || 'AUD';
    function money(c) { return (c / 100).toLocaleString('en-AU', { style: 'currency', currency: currency }); }
    var idInput = $('[data-afw-variant-id]', root), qty = $('[data-afw-qty]', root);

    // Deal of the Week: banner + Save MEGA badge
    var deal = currentDeal(), pid = root.getAttribute('data-product-id');
    var isDeal = !!(deal && ((deal.ids && deal.ids.some(function (i) { return String(i) === pid; })) || String(deal.id) === pid));
    var dotw = $('[data-afw-dotw]', root); if (dotw) dotw.hidden = !isDeal;
    var dotwExtra = $('[data-afw-dotw-extra]', root);
    if (dotwExtra) {
      var showExtra = isDeal && deal.extra > 0;
      dotwExtra.hidden = !showExtra;
      if (showExtra) dotwExtra.textContent = 'Down an extra $' + deal.extra + ' this week';
    }
    function megaSync() {
      var s = $('[data-afw-save]', root); if (!s) return;
      if (!s.querySelector('.mega') && /^Save /.test(s.textContent)) s.innerHTML = s.textContent.replace(/^Save /, 'Save <b class="mega">MEGA</b> ');
      s.classList.toggle('is-mega', isDeal);
    }

    // Add-ons (5-year warranty, fabric protector, assembly): running total on the Add to cart button
    var addons = $$('[data-afw-addon]', root);
    function curVariant() { var id = idInput ? Number(idInput.value) : 0; return product ? product.variants.filter(function (v) { return v.id === id; })[0] : null; }
    var isPreorder = root.getAttribute('data-is-preorder') === 'true';
    var preorderDepositPct = parseFloat(root.getAttribute('data-preorder-deposit-pct')) || 50;
    function syncTotal() {
      var lbl = $('[data-afw-add-label]', root), v = curVariant();
      if (!lbl || !v || !v.available) return;
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      var add = addons.reduce(function (sum, a) { return sum + (a.checked ? (parseFloat(a.getAttribute('data-price')) || 0) * 100 : 0); }, 0);
      var total = (v.price + add) * q;
      if (isPreorder) {
        var payFull = root.querySelector('[data-preorder-pay-radio]:checked');
        var dueToday = (payFull && payFull.value === 'true') ? total : Math.round(total * preorderDepositPct / 100);
        lbl.textContent = 'Pre-order now · ' + money(dueToday);
        return;
      }
      lbl.textContent = 'Add to cart · ' + money(total);
    }
    function refresh() { megaSync(); syncTotal(); }
    addons.forEach(function (a) { a.addEventListener('change', syncTotal); });
    if (qty) qty.addEventListener('input', syncTotal);
    $$('[data-preorder-pay-radio]', root).forEach(function (r) { r.addEventListener('change', syncTotal); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-afw-qty-minus], [data-afw-qty-plus], [data-afw-option]')) setTimeout(refresh, 0);
    });
    refresh();

    // After wishlisting: offer price-drop / Deal of the Week alerts
    var wish = $('.afw-wish', root), notify = $('[data-afw-notify]', root);
    if (wish && notify) {
      wish.addEventListener('click', function () {
        setTimeout(function () {
          var saved = wish.classList.contains('swym-added') || wish.classList.contains('swym-adding') || !window._swat;
          notify.hidden = !saved;
        }, 700);
      });
      if (window.location.search.indexOf('customer_posted=true') > -1 && notify.querySelector('form')) { notify.hidden = false; }
    }
  }

  function init() {
    initHeader(); initWeekly(); syncHeaderSpace(); footerStores();
    if (!window.__afwFooterTimer) window.__afwFooterTimer = setInterval(footerStores, 60000);
    window.addEventListener('resize', syncHeaderSpace); window.addEventListener('load', syncHeaderSpace);
    setTimeout(syncHeaderSpace, 400); setTimeout(syncHeaderSpace, 1200);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeaderSpace);
    if (window.ResizeObserver && !window.__afwRO) {
      window.__afwRO = new ResizeObserver(syncHeaderSpace);
      ['shopify-section-afw-announcement', 'shopify-section-afw-header'].forEach(function (id) { var el = document.getElementById(id); if (el) window.__afwRO.observe(el); });
    }
    $$('[data-afw-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var r = $('#afwHdr'); if (r) r._afw = false; init(); });
})();
